import { useEffect, useState } from 'react';
import { useCurrentUser } from '../stores/UserStore';
import { CONSENTS, GlobalModals } from '../constants/AppConstants';
import ModalActions from '../actions/ModalActions';
import ConsentsActions from '../actions/ConsentsActions';
import { useStoreState } from '../stores/useStoreState';
import ConsentsStore from '../stores/ConsentsStore';

export const useConsents = () => {
    const user = useCurrentUser();
    const hasUser = user && user.id;

    const consents = useStoreState(ConsentsStore);
    const form = consents.form;

    const fetchConsents = async () => {
        if (hasUser) {
            const consentsResponse = await ConsentsActions.getConsents();
            const updatedConsentsForm = form.normalizeConsentsResponse({ consents: consentsResponse, user });
            ConsentsActions.setConsentsForm(updatedConsentsForm);
        } else {
            await ConsentsActions.getConsentsTemplate();
        }
    };

    useEffect(() => {
        fetchConsents();
        // eslint-disable-next-line
    }, []);

    const onCheckNotificationMethod = ({ optionId }) => () => {
        const updatedConsentsFormObj = {
            [optionId]: !consents.form.get(optionId),
        };
        if (optionId === CONSENTS.SMS_Marketing && consents.form.get(optionId)) {
            updatedConsentsFormObj[CONSENTS.PHONE] = '';
        }
        const updatedConsentsForm = form.merge(updatedConsentsFormObj);
        ConsentsActions.setConsentsForm(updatedConsentsForm);
    };

    const onChangePhoneNumber = (field, value) => {
        const updatedConsentsForm = form.set(field, value);
        ConsentsActions.setConsentsForm(updatedConsentsForm);
    };

    const onChangeIsOver16 = choice => () => {
        const updatedConsentsForm = form.set(CONSENTS.OVER_16, choice.reference === CONSENTS.I_CONFIRM_16_YEARS_OLD);
        ConsentsActions.setConsentsForm(updatedConsentsForm);
    };

    const [submitLoading, setSubmitLoading] = useState(false);
    const handleSubmit = async () => {
        if (form.isComplete()) {
            setSubmitLoading(true);
            await ConsentsActions.updateConsentsAndUser({ form, user });
            setSubmitLoading(false);

            ModalActions.open(GlobalModals.INFO, {
                type: 'success',
                title: 'preference-centre.update-success.notification',
            });

            fetchConsents();
        }
    };

    return {
        consents: hasUser ? consents.response : consents.template,
        consentsForm: form,
        onCheckNotificationMethod,
        onChangePhoneNumber,
        onChangeIsOver16,
        handleSubmit,
        submitLoading,
        consentsLoading: consents.isLoading,
        showSubmitButton: hasUser,
    };
};



// WEBPACK FOOTER //
// ./src/hooks/useConsents.js